export default "__VITE_ASSET__C3gB2zBL__"